export default __webpack_public_path__ + "static/media/Global Coverage.5f582424.png";